import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCategories } from '../../../features/companysettings/services/productCategoryService';

// Async thunk to fetch product categories
export const fetchProductCategories = createAsyncThunk(
  'productCategories/fetchProductCategories',
  async (config = {}, { rejectWithValue }) => {
    try {
      const response = await getCategories(config);
      const categoryData = response?.payload || response || [];
      return Array.isArray(categoryData) ? categoryData : [];
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch product categories');
    }
  }
);

const productCategorySlice = createSlice({
  name: 'productCategories',
  initialState: {
    categories: [],
    loading: false,
    error: null,
    lastFetched: null,
  },
  reducers: {
    addCategoryToStore: (state, action) => {
      state.categories.push(action.payload);
    },
    updateCategoryInStore: (state, action) => {
      const index = state.categories.findIndex(c => c.Id === action.payload.Id);
      if (index !== -1) {
        state.categories[index] = action.payload;
      }
    },
    removeCategoryFromStore: (state, action) => {
      state.categories = state.categories.filter(c => c.Id !== action.payload);
    },
    resetCategories: (state) => {
      state.categories = [];
      state.error = null;
      state.lastFetched = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
        state.lastFetched = Date.now();
      })
      .addCase(fetchProductCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { 
  addCategoryToStore, 
  updateCategoryInStore, 
  removeCategoryFromStore, 
  resetCategories 
} = productCategorySlice.actions;

export default productCategorySlice.reducer;
